import { container } from '@client/core/container';
import { Axios, AxiosResponse } from 'axios';
import { Project } from '@client/features/project/models/project';
import { AuthorizedUploadIntent } from '@client/features/attachments/types';

/**
 * Submit an API request to create a Photo Log Photo.
 *
 * Returns a serialized raw Photo Log Photo.
 */
export async function createPhotoLogPhoto(opts: {
  projectUuid: Project['uuid'];
  intent: AuthorizedUploadIntent;
  photoDate: string;
  order: number;
  batchUuid: string;
}): Promise<AxiosResponse> {
  const api = container(Axios);
  const { projectUuid, intent, photoDate, order, batchUuid } = opts;

  return await api.post(`/project/${projectUuid}/photo-log-photo/${intent.uuid}`, {
    photo_date: photoDate,
    order: order,
    batch_id: batchUuid,
  });
}
